import React from 'react';

const CarouselImpl = React.lazy(() =>
  import('./Carousel').then((mod) => ({ default: mod.Carousel }))
);

interface CarouselProps {
  className?: string;
  children: React.ReactNode;
  centerInsufficientSlides?: boolean;
}

export function Carousel(props: CarouselProps) {
  return (
    <React.Suspense fallback={null}>
      <CarouselImpl {...props} />
    </React.Suspense>
  );
}
